import { useEffect, useState } from "react";

// Amplify GraphQL client
import { generateClient } from "aws-amplify/api";

// MUI / Material Dashboard components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

const client = generateClient();

export default function DevicesTable() {
  const [devices, setDevices] = useState([]);

  useEffect(() => {
    async function fetchDevices() {
      const result = await client.graphql({
        query: `
          query ListDevices {
            listDevices {
              items {
                id
                type
                serial
                owner
                customName
              }
            }
          }
        `,
      });
      setDevices(result.data.listDevices.items);
    }
    fetchDevices();
  }, []);

  const table = {
    columns: [
      { Header: "ID", accessor: "id" },
      { Header: "Type", accessor: "type" },
      { Header: "Serial", accessor: "serial" },
      { Header: "Owner", accessor: "owner" },
      { Header: "Custom Name", accessor: "customName" },
    ],
    rows: devices,
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Devices
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={table}
                  isSorted={false}
                  entriesPerPage={{ defaultValue: 10, entries: [5, 10, 15, 20] }}
                  showTotalEntries
                  noEndBorder
                  canSearch
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
